import ComposeViewState from '../store/schema/ComposeViewState';

export default function getInfoBarMessageIdsInCompose(viewState: ComposeViewState): string[] {
    return viewState.infoBarIds;
}
